import { Tarif } from '@wz-models';
import { Assurees } from './Assurees.model';
import { Paiement } from './Paiement.model';
import { Souscription } from './Souscription.model';

export class TarifViewModel {
  assures!: Assurees;
  souscription!: Souscription;
  tarifs!: Tarif[];
  CodeGamme: string = '';
  NomGamme: string | null = '';
  NomCompagnie: string = '';
  Url_cg: string = '';
  Url_tg: string = '';
  Url_annexe: string = '';
  Url_apsap: string = '';
  SelectedFormule: string = '';
  LoiMadelin: boolean = false;
  NoAncienneCompagnie: boolean = false;
  NoCompagnie: boolean = false;
  DateRadie?: Date | null = null;
  CompagnieRadie: string = '';
  NumeroContrat: string = '';
  Aradier: boolean = false;
  MoiResil: boolean = false;
  Motif: string = '';
  Souscripteur: string = '';
  NomSouscripteur: string = '';
  AdresseSouscripteur: string = '';
  DateRadie1: string = '';
  CompagnieRadie1: string = '';
  NumeroContrat1: string = '';
  DateRadie2: string = '';
  CompagnieRadie2: string = '';
  NumeroContrat2: string = '';
  TelaRappeler: string = '';
  eMailRecontacte: string = '';

  constructor(
    assures: Assurees,
    souscription: Souscription,
    tarifs: Tarif[],
    CodeGamme: string,
    NomGamme: string | null,
    NomCompagnie: string,
    Url_cg: string,
    Url_tg: string,
    Url_annexe: string,
    Url_apsap: string,
    SelectedFormule: string,
    LoiMadelin: boolean,
    NoAncienneCompagnie: boolean,
    NoCompagnie: boolean,
    DateRadie: Date | null,
    CompagnieRadie: string,
    NumeroContrat: string,
    Aradier: boolean,
    MoiResil: boolean,
    Motif: string,
    Souscripteur: string,
    NomSouscripteur: string,
    AdresseSouscripteur: string,
    DateRadie1: string,
    CompagnieRadie1: string,
    NumeroContrat1: string,
    DateRadie2: string,
    CompagnieRadie2: string,
    NumeroContrat2: string,
    TelaRappeler: string,
    eMailRecontacte: string,
  ) {
    this.assures = assures;
    this.souscription = souscription;
    this.tarifs = tarifs;
    this.CodeGamme = CodeGamme;
    this.NomGamme = NomGamme;
    this.NomCompagnie = NomCompagnie;
    this.Url_cg = Url_cg;
    this.Url_tg = Url_tg;
    this.Url_annexe = Url_annexe;
    this.Url_apsap = Url_apsap;
    this.SelectedFormule = SelectedFormule;
    this.LoiMadelin = LoiMadelin;
    this.NoAncienneCompagnie = NoAncienneCompagnie;
    this.NoCompagnie = NoCompagnie;
    this.DateRadie = DateRadie;
    this.CompagnieRadie = CompagnieRadie;
    this.NumeroContrat = NumeroContrat;
    this.Aradier = Aradier;
    this.MoiResil = MoiResil;
    this.Motif = Motif;
    this.Souscripteur = Souscripteur;
    this.NomSouscripteur = NomSouscripteur;
    this.AdresseSouscripteur = AdresseSouscripteur;
    this.DateRadie1 = DateRadie1;
    this.CompagnieRadie1 = CompagnieRadie1;
    this.NumeroContrat1 = NumeroContrat1;
    this.DateRadie2 = DateRadie2;
    this.CompagnieRadie2 = CompagnieRadie2;
    this.NumeroContrat2 = NumeroContrat2;
    this.TelaRappeler = TelaRappeler;
    this.eMailRecontacte = eMailRecontacte;
  }
}
export interface TarifContrat {
  codeFormule: string;
  nomFormule: string;
  prix: number;
}
export interface ValueSubscribe {
  assures: Assurees;
  subscribe: Souscription;
}
export interface DisplayValues {
  subscribe?: Souscription;
  tarifViewModel?: TarifViewModel | null;
  paiement?: Paiement | null;
  assurees?: Assurees | null;
}
